

export const HN_NOTIFIER_PUBLIC_TOKEN_COOKIE_KEY_NAME = 'hn-notifier.public-jwt';
export const NEXT_AUTH_SESSION_TOKEN_COOKIE_KEY_NAME = 'next-auth.session-token';